/* ============================================================
   SNUG CAMP MAT — Theme JavaScript
   All animations, carousels, header scroll, mobile nav
   ============================================================ */

(function () {
  'use strict';

  /* ── Utility: wait for DOM ── */
  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  /* ── 1. Header: transparent → solid on scroll ── */
  function initHeader() {
    var header = document.querySelector('.snug-header');
    if (!header) return;

    function updateHeader() {
      if (window.scrollY > 40) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }

    window.addEventListener('scroll', updateHeader, { passive: true });
    updateHeader();
  }

  /* ── 2. Mobile Navigation ── */
  function initMobileNav() {
    var hamburger = document.querySelector('.snug-header__hamburger');
    var mobileNav = document.querySelector('.snug-mobile-nav');
    var closeBtn  = document.querySelector('.snug-mobile-nav__close');
    if (!hamburger || !mobileNav) return;

    hamburger.addEventListener('click', function () {
      mobileNav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        mobileNav.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    }

    // Close on outside click
    mobileNav.addEventListener('click', function (e) {
      if (e.target === mobileNav) {
        mobileNav.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  }

  /* ── 3. Featured Product Carousel ── */
  function initFeaturedCarousel() {
    var slides   = document.querySelectorAll('.snug-featured__slide');
    var prevBtns = document.querySelectorAll('.snug-featured__nav-btn--prev');
    var nextBtns = document.querySelectorAll('.snug-featured__nav-btn--next');
    if (!slides.length) return;

    var current = 0;

    function showSlide(idx) {
      slides.forEach(function (s) { s.classList.remove('is-active'); });
      current = (idx + slides.length) % slides.length;
      slides[current].classList.add('is-active');
    }

    prevBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { showSlide(current - 1); });
    });
    nextBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { showSlide(current + 1); });
    });

    // Auto-advance every 5s
    setInterval(function () { showSlide(current + 1); }, 5000);
    showSlide(0);
  }

  /* ── 4. Fun Fact Carousel ── */
  function initFunFact() {
    var slides   = document.querySelectorAll('.snug-funfact__slide');
    var prevBtns = document.querySelectorAll('.snug-funfact__nav-btn--prev');
    var nextBtns = document.querySelectorAll('.snug-funfact__nav-btn--next');
    if (!slides.length) return;

    var current = 0;

    function showFact(idx) {
      slides.forEach(function (s) { s.classList.remove('is-active'); });
      current = (idx + slides.length) % slides.length;
      slides[current].classList.add('is-active');
    }

    prevBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { showFact(current - 1); });
    });
    nextBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { showFact(current + 1); });
    });

    setInterval(function () { showFact(current + 1); }, 6000);
    showFact(0);
  }

  /* ── 5. Use Cases Tab ── */
  function initUseCases() {
    var tabs = document.querySelectorAll('.snug-usecases__tab');
    var cards = document.querySelectorAll('.snug-usecases__card-panel');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');

        var target = tab.getAttribute('data-usecase');
        cards.forEach(function (card) {
          if (card.getAttribute('data-usecase') === target) {
            card.style.display = 'block';
          } else {
            card.style.display = 'none';
          }
        });
      });
    });

    // Activate first tab
    if (tabs[0]) tabs[0].click();
  }

  /* ── 6. Scroll Reveal Animation ── */
  function initScrollReveal() {
    var elements = document.querySelectorAll('[data-snug-reveal]');
    if (!elements.length) return;

    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    elements.forEach(function (el) { observer.observe(el); });
  }

  /* ── 7. Announcement bar duplicate for seamless loop ── */
  function initMarquee() {
    var tracks = document.querySelectorAll('.snug-announcement__track, .snug-ticker__track');
    tracks.forEach(function (track) {
      var items = track.innerHTML;
      track.innerHTML = items + items; // duplicate for seamless loop
    });
  }

  /* ── 8. Hero video fallback ── */
  function initHeroVideo() {
    var videos = document.querySelectorAll('.snug-hero__video');
    videos.forEach(function (video) {
      video.setAttribute('playsinline', '');
      video.setAttribute('muted', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('loop', '');
      video.muted = true;
      video.play().catch(function () {
        // Show poster image on autoplay failure
        var wrap = video.closest('.snug-hero__video-wrap');
        if (wrap) wrap.style.backgroundSize = 'cover';
      });
    });
  }

  /* ── Init All ── */
  ready(function () {
    initHeader();
    initMobileNav();
    initFeaturedCarousel();
    initFunFact();
    initUseCases();
    initScrollReveal();
    initMarquee();
    initHeroVideo();
  });

})();
